import { showModalError } from './modal';
import { t } from './lang';
import { ERROR_CODE } from 'constants/api';

class ErrorHandler {
  static getErrorData(err) {
    return err;
  }

  static getMessage(err, fallback = '') {
    const errData = this.getErrorData(err);
    if (errData?.code === ERROR_CODE.EXTERNAL_ERROR) {
      return errData.message || fallback;
    }
    return (
      t(`error.message.${errData?.code}`, errData?.errorparameters) ||
      errData?.message ||
      fallback
    );
  }

  static isEqualToCode(err, code) {
    const errData = this.getErrorData(err);
    return errData && errData.code === code;
  }

  static showError(err, options = {}) {
    const initOptions = { onOk: () => {}, title: 'Error!' };
    options = { ...initOptions, ...options };
    const { onOk, title } = options;
    const errData = this.getErrorData(err);
    if (errData && errData.message) {
      showModalError({
        title,
        content: this.getMessage(errData, 'You\'re having problems with your network connection. Please try again.'),
        onOk,
        okText: t('common.ok'),
      });
    }
  }
}

export default ErrorHandler;
